/** Read the base palette for browser APIs that cannot consume CSS var() values. */
export function readCssColours<const Names extends readonly `--${string}`[]>(
  element: Element,
  names: Names,
): Record<Names[number], string> {
  const view = element.ownerDocument.defaultView;
  if (view === null) throw new Error("The colour palette requires a browser document.");
  const style = view.getComputedStyle(element);
  return Object.fromEntries(
    names.map((name) => {
      const value = style.getPropertyValue(name).trim();
      if (value.length === 0) throw new Error(`The shared colour ${name} is missing.`);
      return [name, value];
    }),
  ) as Record<Names[number], string>;
}

export function installThemeColour(document: Document): void {
  const colours = readCssColours(document.documentElement, ["--blue-deep"]);
  const existing = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  const meta = existing ?? document.createElement("meta");
  meta.name = "theme-color";
  meta.content = colours["--blue-deep"];
  if (existing === null) document.head.append(meta);
}
